import { Delay } from "../modules/types/intake-funnel";
import { DELAY_TO_MINUTES_MAP } from "../settings/constants";

export function delayToMinutes(delay: Delay) {
  return DELAY_TO_MINUTES_MAP[delay];
}
